const e = {
  "@ado/acs-standard-library": {
    "loading-bar": {
      "loading-message": () => "En cours de préparation."
    },
    "contact-list": {
      "name-label": () => "Nom",
      "email-label": () => "Votre adresse email"
    },
    "contact-validator": {
      "duplicate-contact-message": () => "Cette personne a déjà été ajoutée",
      "maximum-recipients-message": () => "Nombre maximum de destinataires atteint pour cette invitation",
      "invalid-email-message": () => "Veuillez indiquer une adresse email valide",
      "invalid-name-message": () => "Vous devez entrer un nom"
    },
    "invitation-dialog": {
      "send-invite": () => "Envoyer une invitation"
    }
  }
};
export {
  e as default
};
//# sourceMappingURL=index.js.map
